import React, { Component } from 'react'
import { StaticBox, LinkedInput, LinkedToggle, LinkedInputGroup } from 'components/basic'
import { notify, FormHelper } from 'helpers'
import http from 'API/http'
import { connect } from 'react-redux'

class UserCreator extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: {}
    }
  }

  async createUser () {
    var valid = await FormHelper.validate(this.form)
    if (!valid) return
    var [err, res] = await http.post('2.4/users/', this.state.user)
    if (err) return notify.alert('', res.cause ? res.cause : 'Creating  user failed', 'error')
    notify.success('User created')
    window.location = '/#/users/' + res.data.userId
    this.setState({editable: false})
  }

  render () {
    return (
      <StaticBox cols={12} icon='user' title='Create' buttons={[ { icon: 'fa-save', event: () => this.createUser(), datatip: 'Save' } ]}>
        <div className='row'>
          <LinkedInputGroup ref={(form) => { this.form = form }}>
            <div className='col-md-3'>
              <label>Name</label>
              <LinkedInput context={this} path='user.name' validate={/.{1,}/} errorMessage='This field is required' />
            </div>
            <div className='col-md-3'>
              <label>Email</label>
              <LinkedInput context={this} path='user.email' validate={/^\S+@\S+\.\S+$/} errorMessage='Wrong format' />
            </div>
            <div className='col-md-3'>
              <label>Password</label>
              <LinkedInput type='password' context={this} editable={this.state.editable} path='user.password' name='password' validate={/^((?!.*[\s])(?=.*[A-Öa-ö0-9]).{8,100})/} errorMessage='Minimum of 8 characters in length, (A-ö, 0-9, !"#€%&/\()=?`")'/>
            </div>
          </LinkedInputGroup>
            <div className='col-md-3'>
              <label>Administrator</label>
              <LinkedToggle context={this} path='user.isAdmin' name='Administrator' />
            </div>
        </div>
      </StaticBox>
    )
  }
}

//eslint-disable-next-line
UserCreator = connect(state => state.siteReducer)(UserCreator)
export default UserCreator



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/users/UserCreator.js